function Skeleton() {
  return (
    <div className="absolute inset-0 z-10 -mx-2 -mb-4 bg-white px-4 dark:bg-gray-800 md:-mx-4">
      {/* Tabs row skeleton */}
      <div className="relative -mx-1 mb-4 flex items-center gap-2 overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-l from-purple-50/30 via-white to-purple-50/20 p-1.5 dark:border-gray-700/60 dark:from-purple-950/15 dark:via-gray-800 dark:to-purple-950/10">
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 -translate-x-full animate-[reportShimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/5"
        />
        <div className="relative h-9 w-24 rounded-2xl bg-gradient-to-br from-purple-200 to-purple-300 dark:from-purple-700 dark:to-purple-800" />
        <div className="relative h-9 w-28 rounded-2xl bg-gray-100 dark:bg-gray-700" />
        <div className="relative h-9 w-24 rounded-2xl bg-gray-100 dark:bg-gray-700" />
        <div className="relative h-9 w-32 rounded-2xl bg-gray-100 dark:bg-gray-700" />
      </div>

      {/* Table skeleton */}
      <div className="relative overflow-hidden rounded-2xl border border-gray-100 dark:border-gray-700/60">
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 -translate-x-full animate-[reportShimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/5"
        />

        {/* Table header */}
        <div className="relative flex items-center gap-8 border-b border-gray-100 bg-gradient-to-l from-purple-50/30 via-gray-50/70 to-gray-50/40 px-5 py-3.5 dark:border-gray-700/60 dark:from-purple-950/15 dark:via-gray-900/60 dark:to-gray-900/40">
          <div className="h-3 w-24 rounded-full bg-gray-200/80 dark:bg-gray-700" />
          <div className="h-3 w-20 rounded-full bg-gray-200/80 dark:bg-gray-700" />
          <div className="h-3 w-28 rounded-full bg-gray-200/80 dark:bg-gray-700" />
          <div className="h-3 w-16 rounded-full bg-gray-200/80 dark:bg-gray-700" />
        </div>

        {/* Rows */}
        {Array(5)
          .fill(0)
          .map((_, i) => (
            <div
              key={i}
              className="relative flex items-center gap-8 border-b border-gray-100 px-5 py-4 last:border-0 dark:border-gray-700/40"
            >
              <div className="h-3.5 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-100 dark:from-gray-700 dark:to-gray-800" />
              <div className="h-3.5 w-20 rounded-full bg-gray-100 dark:bg-gray-800" />
              <div className="h-3.5 w-24 rounded-full bg-gray-100 dark:bg-gray-800" />
              <div className="h-3.5 w-20 rounded-full bg-gradient-to-r from-purple-100/60 to-purple-50/30 dark:from-purple-950/40 dark:to-purple-950/20" />
            </div>
          ))}
      </div>

      <style>{`@keyframes reportShimmer { 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
}

export default Skeleton;
